/* @sravni/react-design-system version 0.2.60 */
var css = "._95yy9x {\n  overflow: hidden;\n}\n._1ksuk3 {\n  display: block;\n}\n._psn6eu {\n  display: none;\n}\n";
var modules_a1e6048f = {"collapseOverflow":"_95yy9x","collapseVisible":"_1ksuk3","collapseHidden":"_psn6eu"};
import "../../../assets/components/Transition/index-8edc1087.css";

export default modules_a1e6048f;
export { css };
